<template>
  <div class="px-page mb-8">
    <h2 class="font-semibold text-xl leading-tight">
      Dashboard
    </h2>
  </div>

  <div class="mt-8 px-page">
    <div>
      <h3 class="text-base font-semibold leading-6 text-gray-900">Orders Left to Ship</h3>
      <dl class="mt-5 grid grid-cols-1 gap-5 sm:grid-cols-5">
        <div class="overflow-hidden rounded-lg bg-white px-4 py-5 shadow sm:p-4">
          <dt class="flex items-start justify-between truncate text-sm font-medium text-gray-500">
            <span>Orders Left to Ship</span>
            <ArrowPathIcon v-on:click="ordersLeftToShipRefresh" class="w-5 h-5 cursor-pointer" v-bind:class="{'animate-spin': loading}" />
          </dt>
          <dd class="mt-1 text-3xl font-semibold tracking-tight text-gray-900">
            {{ count }}
            <Link v-bind:href="$route('orders.left-to-ship')">
              <ArrowTopRightOnSquareIcon class="inline-block w-5 h-5 text-gray-500" />
            </Link>
          </dd>
        </div>
      </dl>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import { Link } from '@inertiajs/vue3';
import { fetchData } from '../composables/Widgets';
import { ArrowPathIcon, ArrowTopRightOnSquareIcon } from '@heroicons/vue/20/solid';

const { ordersLeftToShip } = defineProps(['ordersLeftToShip']);

const loading = ref(false);
const count = ref(ordersLeftToShip.length);

const ordersLeftToShipRefresh = () => {
  loading.value = true;
  fetchData('orders-left-to-ship')
    .then(orders => {
      count.value = orders.length;
      loading.value = false;
    })
    .catch(err => {
      loading.value = false;
    })
}
</script>
